import { Accordion, ButtonText } from '@morressier/alembic';
import { faBell, faBoxArchive } from '@fortawesome/pro-regular-svg-icons';
import { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { IconBadge } from 'src/components/IconBadge';
import { WithdrawalContextModal } from 'src/components/Submission/modals/WithdrawalContextModal';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import AdditionalInformationWrapper from '../../AdditionalInformationWrapper';

export const EditorialWithdrawnAdditionalInfo = () => {
  const { withdrawal } = useSubmissionData();
  const [showContextModal, setShowContextModal] = useState(false);

  return (
    <AdditionalInformationWrapper>
      <Accordion
        chakraAccordionProps={{
          width: '100%',
          defaultIndex: 0
        }}
        items={[
          {
            title: (
              <Flex alignItems={'flex-start'} gap={2}>
                <IconBadge icon={faBell} variant="neutral" />
                <Flex flexDirection={'column'} marginLeft={2}>
                  <Text textStyle="headingItem">Highlights</Text>
                  <Text textStyle="textContext">
                    Review key updates and other relevant information in this
                    phase.
                  </Text>
                </Flex>
              </Flex>
            ),
            content: (
              <Flex flexDirection="column" width="100%" gap={4}>
                <Flex gap={3} alignItems="center">
                  <IconBadge icon={faBoxArchive} variant="attention" />
                  <Text textStyle="headingItem">Submission Withdrawn</Text>
                  <ButtonText
                    marginLeft="auto"
                    onClick={() => setShowContextModal(true)}
                  >
                    View Details
                  </ButtonText>
                </Flex>
              </Flex>
            )
          }
        ]}
      />

      {showContextModal && (
        <WithdrawalContextModal
          role="editorial"
          type="EditorialSubmissionWithdrawn"
          data={withdrawal}
          onClose={() => setShowContextModal(false)}
        />
      )}
    </AdditionalInformationWrapper>
  );
};
